import React from 'react';
import { AIDrawingLiveDemo } from './AIDrawingLiveDemo';

const AIDrawingSpotlight = () => {
  return (
    <section className="relative py-20 md:py-28 bg-background">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-foreground">
          Desenho que ganha vida com <span className="text-warm-ink dark:text-warm">IA</span>
        </h2>
        <p className="font-body text-lg text-muted-foreground mt-4 max-w-xl mx-auto">
          A forma mais lúdica de aprender letras e números — com reconhecimento
          inteligente e feedback na hora.
        </p>

        <div className="relative mt-12 mx-auto max-w-md rounded-[2.5rem] bg-warm/[0.07] dark:bg-warm/[0.1] p-6 md:p-8 overflow-hidden">
          <div
            className="absolute inset-0 flex items-center justify-center pointer-events-none"
            aria-hidden="true"
          >
            <div
              className="w-[340px] h-[340px] rounded-full opacity-40 blur-3xl"
              style={{ background: 'radial-gradient(circle, rgb(var(--warm)) 0%, transparent 70%)' }}
            />
          </div>
          <div className="relative">
            <AIDrawingLiveDemo />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIDrawingSpotlight;
